const techStackOptions = [
    { label: 'WordPress', value: 'wordpress', category: 'CMS' },
    { label: 'HTML', value: 'html', category: 'Frontend' },
    { label: 'CSS', value: 'css', category: 'Frontend' },
    { label: 'TailwindCSS', value: 'tailwind', category: 'Frontend' },
    { label: 'Bootstrap', value: 'bootstrap', category: 'Frontend' },
    { label: 'JavaScript', value: 'javascript', category: 'Frontend' },
    { label: 'React', value: 'react', category: 'Frontend' },
    { label: 'NextJS', value: 'nextjs', category: 'Frontend' },
    { label: 'Vue', value: 'vue', category: 'Frontend' },
    { label: 'React Native', value: 'react-native', category: 'Mobile' },
    { label: 'NodeJS', value: 'nodejs', category: 'Backend' },
    { label: 'PHP', value: 'php', category: 'Backend' },
    { label: 'Laravel', value: 'laravel', category: 'Backend' },
    { label: 'C#', value: 'c#', category: 'Backend' },
    { label: '.NET', value: '.net', category: 'Backend' },
    { label: 'GO', value: 'go', category: 'Backend' },
    { label: 'Java', value: 'java', category: 'Backend' },
    {
      label: 'Apache Server',
      value: 'apacheserver',
      category: 'Infrastructure',
    },
    { label: 'Nginx', value: 'nginx', category: 'Infrastructure' },
    { label: 'REST', value: 'rest', category: 'Infrastructure' },
    { label: 'RPC', value: 'rpc', category: 'Infrastructure' },
    { label: 'Kafka', value: 'kafka', category: 'Infrastructure' },
    { label: 'Firebase', value: 'firebase', category: 'Database' },
    { label: 'MongoDB', value: 'mongodb', category: 'Database' },
    { label: 'MySQL', value: 'mysql', category: 'Database' },
    { label: 'PostgreSQL', value: 'postgres', category: 'Database' },
    { label: 'SQL Server', value: 'sqlserver', category: 'Database' },
    { label: 'Git', value: 'git', category: 'Tools' },
    { label: 'Docker', value: 'docker', category: 'DevOps' },
    { label: 'Kubernetes', value: 'kubernetes', category: 'DevOps' },
    { label: 'Azure', value: 'azure', category: 'Cloud' },
    { label: 'AWS', value: 'aws', category: 'Cloud' },
  ];

   const designToolsOptions = [
    { label: 'Adobe Photoshop', value: 'photoshop', category: 'Adobe Creative Suite' },
    { label: 'Adobe Illustrator', value: 'illustrator', category: 'Adobe Creative Suite' },
    { label: 'Adobe After Effects', value: 'aftereffects', category: 'Adobe Creative Suite' },
    { label: 'Figma', value: 'figma', category: 'UI/UX Tools' },
    { label: 'Adobe XD', value: 'xd', category: 'UI/UX Tools' },
    { label: 'Sketch', value: 'sketch', category: 'UI/UX Tools' },
    { label: 'InVision', value: 'invision', category: 'Prototyping' },
    { label: 'Framer', value: 'framer', category: 'Prototyping' },
    { label: 'Principle', value: 'principle', category: 'Prototyping' },
  ];

  export { techStackOptions, designToolsOptions };